import { post } from "@/utils/utils";
import moment from "moment";
const memberCenter = {
  state: {
    memberMgtList: {},
    detMemberMgt: {
      labelInfoVos: [],
      couponNum: 0
    },
    detailMember: {},
    vipCardList: {},
    cardTypeList: {},
    vipCardTypeList: {},
    memberInfoList: {},
    allMemberMgtList: {},
    fansMgtList: {},
    allFansMgtList: {},
    virtualGoods: {},
    plusRuleList: {},
    plusPageList: {},
    plusMemberList: {},
    plusRightMoveList: {},
    plusRuleDetails: null,
    rightsProgress: { cards: [] }
  },
  mutations: {
    //会员中心列表
    QUERY_MEMBERMGT_LIST(state, data) {
      state.memberMgtList = data.result;
    },
    QUERY_ALLMEMBERMGT_LIST(state, data) {
      state.allMemberMgtList = data.result;
    },
    SEARCH_BY_PHONE_OR_CARD_ID(state, data) {
      state.allMemberMgtList = data.result;
    },
    //查看会员中心详情
    DETAILS_MEMBERMGT_MGT(state, data) {
      state.detMemberMgt = data.result;
    },
    QUERY_CUSTOMER_COUPON() {},
    //查看会员卡详情
    DETAIL_MEMBER_ID(state, data) {
      state.detailMember = data.result;
    },
    //编辑会员卡
    EDIT_MEMBERMGT(state, data) {
      state.editMember = data.result;
    },
    //新增会员卡
    ADD_MEMBERMGT(state, data) {
      state.addMember = data.result;
    },
    //查看会员卡列表
    QUERY_VIPCARD_LIST(state, data) {
      state.vipCardList = data.result;
    },
    //会员卡类型列表
    QUERY_CARDTYPE_LIST(state, data) {
      state.cardTypeList = data.result;
    },
    //批量分配导购
    BATCH_ALLOCATION(state, data) {
      state.batchall = data.result;
    },
    //商城卡类型列表
    QUERY_VIPCARDTYPE_LIST(state, data) {
      state.vipCardTypeList = data.result;
      state.vipCardTypeList.records.forEach(v => {
        v.disabled = false;
      });
    },
    //会员卡类型详情
    DETAILS_VIPCARDTYPE(state, data) {
      state.detailsVipCardType = data.result;
    },
    //编辑会员卡类型
    EDIT_VIPCARDTYPE(state, data) {
      state.editVipCardType = data.result;
    },
    //会员资料配置列表
    QUERY_MEMBERINFO_LIST(state, data) {
      state.memberInfoList = data.result;
    },
    //会员资料配置详情
    DETAILS_MEMBERINFO(state, data) {
      state.detailsMemberInfo = data.result;
    },
    //编辑会员资料配置
    EDIT_MEMBERINFO(state, data) {
      state.editMemberInfo = data.result;
    },
    //粉丝管理列表
    QUERY_FANSMGT_LIST(state, data) {
      state.fansMgtList = data.result;
    },
    QUERY_ALLFANSMGT_LIST(state, data) {
      state.allFansMgtList = data.result;
    },
    QUERY_ALLFANSMGT_LISTS(state, data) {
      state.allFansMgtLists = data.result;
    },
    //虚拟商品
    VIRTUAL_GOODS(state, data) {
      state.virtualGoods = data.result;
    },
    //plus会员规则列表
    PLUS_RULE_LIST(state, data) {
      state.plusRuleList = data.result;
    },
    //新增plus会员规则列表
    ADD_PLUS_RULE(state, data) {
      state.addplusRuleList = data.result;
    },
    EDIT_PLUS_RULE() {},
    CHANGE_PLUS_RULE_STATUS() {},
    QUERY_PLUS_RULE_DETAIL() {},
    //plus基础配置
    PLUS_BASIC_CONFIG(state, data) {
      state.plusBasicConfig = data.result;
    },
    //plus权益页面
    PLUS_PAGE_LIST(state, data) {
      state.plusPageList = data.result;
    },
    //plus权益页面增删改查
    ADD_PLUS_PAGE_LIST(state, data) {
      state.addplusPageList = data.result;
    },
    //plus会员列表
    PLUS_MEMBER_LIST(state, data) {
      state.plusMemberList = data.result;
      state.plusMemberList.records.forEach(v => {
        v.plusCardInfo = v.plusCardInfoJson
          ? JSON.parse(v.plusCardInfoJson)
          : [];
        const cardTermEndTimeList = v.plusCardInfo.map(v =>
          new Date(v.cardTermEndTime).getTime()
        );
        const max = Math.max.apply(null, cardTermEndTimeList);
        const now = new Date().getTime();
        v.cardEndDate = moment(max).format("YYYY-MM-DD HH:mm:ss");
        v.timeDays = Math.round((max - now) / 1000 / 60 / 60 / 24);
        v.timeDay = max - now;
      });
    },
    GET_RECOMMEND_CODE_LIST() {},
    PLUS_ALL_MEMBER_LIST() {},
    //PLUS会员转移列表
    QUERY_PLUS_RIGHT_MOVE_LIST(state, data) {
      state.plusRightMoveList = data?.result || { records: [], total: 0 };
    },
    //会员权益进度查询
    MEMBER_RIGHTS_PROGRESS(state, data) {
      state.rightsProgress = data.result || { cards: [] };
    },
    ADD_CRM_PLAN(state, data) {
      state.addCrmPlan = data.result;
    },
    FIND_COUPON_SEND_EVENT(state, data) {
      state.findCouponSendByEvent = data.result;
    },
    QUERY_CRM_PLAN_LIST(state, data) {
      state.crmPlanList = data.result;
    },
    QUERY_CRM_PLAN_TYPE(state, data) {
      state.crmPlanttttt = data.result;
    },
    DETAILS_CRM_PLAN_LIST(state, data) {
      state.detailCrmPlanList = data.result;
    },
    EDIT_CRM_PLAN_LIST(state, data) {
      state.editCrmPlanList = data.result;
    },
    DEL_CRM_PLAN_LIST(state, data) {
      state.delCrmPlanList = data.result;
    },
    QUERY_SYS_CONFIG(state, data) {
      state.querySysConfig = data.result;
    },
    EDIT_MEMBER_GROUP_CONFIG(state, data) {
      state.editMemberGroupConfig = data.result;
    },
    QUERY_AGE_GROUP_CONFIG(state, data) {
      state.queryAgeGroupConfig = data.result;
    },
    EDIT_AGE_GROUP_CONFIG(state, data) {
      state.edityAgeGroupConfig = data.result;
    },
    QUERY_UNUSED_LIST() {},
    BALANCE_REFUND() {},
    BATCH_MEMBER_ADD() {},
    STORE_MEMBER_CENTER_INFO() {},
    RIGHT_MOVE() {},
    RIGHT_MOVE_DO() {},
    RIGHT_CANCEL() {},
    DEL_CENTER_LABEL() {},
    QUERY_ALL_LABEL() {},
    ADD_LABEL_CENTER() {},
    QUERY_ALL_VIPCARDTYPE_LIST() {},
    BASIC_CONFIG_INFO() {},
    TEST_CRM_PLAN() {},
    TEST_AUTO_TASK() {},
    QUERY_INTEGRAL_RULE_LIST() {},
    QUERY_INTEGRAL_RULE_DETAILS() {},
    EDIT_INTEGRAL_RULE_DETAILS() {},
    QUERY_INTEGRAL_DUE_RULE() {},
    SAVE_INTEGRAL_DUE_RULE() {},
    BATCH_ALLOTR() {},
    MEMBER_CANCEL() {},
    QUERY_STORE_MEMBER_REFER_CHANGE() {},
    QUERY_REG_REWARD_CONFIG() {},
    QUERY_MEMBER_REG_REWARD_CONFIG() {},
    SAVE_REG_REWARD_CONFIG() {},
    EDIT_REG_REWARD_CONFIG() {},
    ADD_MEMBER_ASSISTANT() {},
    MEMBER_GOLD_BEAN_INFO() {},
    MEMBER_GOLD_BEAN_FLOW() {},
    APPLY_EDIT_MEMBER_GOLD_BEAN_NUM() {},
    STORE_MEMBER_CENTER_INFO_PLUS() {},
    BASIC_PLUS_RULE_LIST() {},
    MP_MEMBER() {},
    //会员数据转移
    MEMBER_DATA_MOVE() {},
    //短信验证码
    SEND_CODE(){},
    //查询授权过的小程序
    QUERY_MEMBER_RECORD(){},
    QUERY_INVITATION_LOAD(){},
    QUERY_INVITATION_ADD(){},
    QUERY_INVITATION_EDIT(){},
    QUERY_INVITATIONS(){},
    QUERY_BE_INVITATIONS(){},
    QUERY_PLUS_OVERDUE(){},
    SETTING_PLUS_OVERDUE(){},
    UPDATE_OVERDUE_SMS_REMINDER_DATE_RULE(){},
    OVERDUE_SMS_REMINDER_BEFORE_DATE_RANG(){},
    QUERY_PLUS_RIGHT_AD_COUPON_LIST() {},
    SYNC_PLUS_MEMBER_SEND_DETAILS(){},
    REMOVE_MEMBER_BY_MOBILE() {}
  },
  actions: {
    queryMemberMgtList({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/list`,
        name: "QUERY_MEMBERMGT_LIST",
        params
      });
    },
    //会员中心列表
    queryAllMemberMgtList({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/list`,
        name: "QUERY_ALLMEMBERMGT_LIST",
        params
      });
    },
    searchByPhoneOrCardId({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/search`,
        name: "SEARCH_BY_PHONE_OR_CARD_ID",
        params
      });
    },
    //查看会员中心详情
    detailsMemberMgt({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/query_details`,
        name: "DETAILS_MEMBERMGT_MGT",
        params
      });
    },
    //会员数据转移
    memberDataMove({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/member_data_move`,
        name: "MEMBER_DATA_MOVE",
        params
      });
    },
    sendCode({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/message/sendCode`,
        name: "SEND_CODE",
        params
      });
    },
    queryCustomerCoupon({ commit }, params) {
      return post({
        commit,
        url: `/coupon/showCoupon`,
        name: "QUERY_CUSTOMER_COUPON",
        params
      });
    },
    //查看会员卡详情
    detailMemberId({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/query_card_info`,
        name: "DETAIL_MEMBER_ID",
        params
      });
    },
    //编辑会员卡
    editMemberMgt({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/edit`,
        name: "EDIT_MEMBERMGT",
        params
      });
    },
    //新增会员卡
    addMemberMgt({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/add`,
        name: "ADD_MEMBERMGT",
        params
      });
    },
    //查看会员卡列表
    queryVipCardList({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCardInfo/list`,
        name: "QUERY_VIPCARD_LIST",
        params
      });
    },
    //会员卡类型列表
    queryCardTypeList({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCardInfo/query_cardType_info`,
        name: "QUERY_CARDTYPE_LIST",
        params
      });
    },
    //批量分配导购
    batchAllocation({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/batch_allocation`,
        name: "BATCH_ALLOCATION",
        params
      });
    },
    //会员卡类型列表
    queryVipCardTypeList({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeCardTypeInfo/list`,
        name: "QUERY_VIPCARDTYPE_LIST",
        params
      });
    },
    queryAllVipCardTypeList({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeCardTypeInfo/list`,
        name: "QUERY_ALL_VIPCARDTYPE_LIST",
        params
      });
    },
    //会员卡类型详情
    detailsVipCardType({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeCardTypeInfo/details`,
        name: "DETAILS_VIPCARDTYPE",
        params
      });
    },
    //编辑会员卡类型
    editVipCardTypeMgt({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeCardTypeInfo/edit`,
        name: "EDIT_VIPCARDTYPE",
        params
      });
    },
    //会员资料配置列表
    queryMemberInfoSettingList({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberRegConfig/list`,
        name: "QUERY_MEMBERINFO_LIST",
        params
      });
    },
    //会员资料配置详情
    detailsMemberInfo({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberRegConfig/details`,
        name: "DETAILS_MEMBERINFO",
        params
      });
    },
    //编辑会员资料配置
    editMemberInfo({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberRegConfig/edit`,
        name: "EDIT_MEMBERINFO",
        params
      });
    },
    //粉丝管理列表
    queryFansMgtList({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberFansInfo/list`,
        name: "QUERY_FANSMGT_LIST",
        params
      });
    },
    //粉丝管理列表
    queryAllFansMgtList({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberFansInfo/list`,
        name: "QUERY_ALLFANSMGT_LIST",
        params
      });
    },
    //初始化
    queryAllFansMgtLists({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberRegConfig/allocation_member_reg`,
        name: "QUERY_ALLFANSMGT_LISTS",
        params
      });
    },
    //虚拟商品
    virtualGoods({ commit }, params) {
      return post({
        commit,
        url: `basic/wxshopspu/sku_list`,
        name: "VIRTUAL_GOODS",
        params
      });
    },
    //plus会员规则列表
    plusRuleList({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/rule/list`,
        name: "PLUS_RULE_LIST",
        params
      });
    },
    //新增plus会员规则列表
    addPlusRuleList({ commit }, params) {
      // return post({
      //   commit,
      //   url: `/basic/plus/rule/add_edit`,
      //   name: "ADD_PLUS_RULE",
      //   params
      // });
      return post({
        commit,
        url: `/basic/plus/rule/add/2.0`,
        name: "ADD_PLUS_RULE",
        params
      });
    },
    editPlusRuleList({ commit }, params) {
      // return post({
      //   commit,
      //   url: `/basic/plus/rule/add_edit`,
      //   name: "ADD_PLUS_RULE",
      //   params
      // });
      return post({
        commit,
        url: `/basic/plus/rule/edit/2.0`,
        name: "EDIT_PLUS_RULE",
        params
      });
    },
    changePlusRuleStatus({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/rule/up_down/2.0`,
        name: "CHANGE_PLUS_RULE_STATUS",
        params
      });
    },
    queryPlusRuleDetail({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/rule/detail/2.0`,
        name: "QUERY_PLUS_RULE_DETAIL",
        params
      });
    },
    //plus基础配置
    plusBasicConfig({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/rule/basic_config`,
        name: "PLUS_BASIC_CONFIG",
        params
      });
    },
    //plus权益页面
    plusPageList({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/right_ad/list`,
        name: "PLUS_PAGE_LIST",
        params
      });
    },
    //plus权益页面增删改查
    addPlusPageList({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/right_ad/add_edit`,
        name: "ADD_PLUS_PAGE_LIST",
        params
      });
    },
    //plus会员列表
    plusMemberList({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/member/list`,
        name: "PLUS_MEMBER_LIST",
        params
      });
    },
    //PLUS会员转移列表
    queryPlusRightMoveList({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/sys/storeOperationLog/plusRightMove/list`,
        name: "QUERY_PLUS_RIGHT_MOVE_LIST",
        params
      });
    },
    //会员权益进度查询（PLUS会员联名卡权益查询明细展示）
    queryMemberRightsProgress({ commit }, params) {
      return post({
        commit,
        url: `/provider/order/micro/plus/storeMemberRightsProgress/queryMemberRightsProgress`,
        name: "MEMBER_RIGHTS_PROGRESS",
        params
      });
    },
    // 获取推荐记录列表
    getRecommendCodeList({ commit }, params) {
      return post({
        commit,
        url: `/mobile_mall/get_cardInfo_recommend_code_page`,
        name: "GET_RECOMMEND_CODE_LIST",
        params
      });
    },
    plusAllMemberList({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/member/list`,
        name: "PLUS_ALL_MEMBER_LIST",
        params
      });
    },
    plusAllMemberListOutput({ commit }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/plusMemberListExport`,
        name: "PLUS_ALL_MEMBER_LIST",
        params
      });
    },
    addCrmPlan({ commit }, params) {
      return post({
        commit,
        url: `/basic/crm_plan/add`,
        name: "ADD_CRM_PLAN",
        params
      });
    },
    findCouponSendB({ commit }, params) {
      return post({
        commit,
        url: `storeCouponSend/findCouponSendByEvent`,
        name: "FIND_COUPON_SEND_EVENT",
        params
      });
    },
    queryCrmPlanList({ commit }, params) {
      return post({
        commit,
        url: `/basic/crm_plan/list`,
        name: "QUERY_CRM_PLAN_LIST",
        params
      });
    },
    queryCrmPlanTypet({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=crm_plan_type`,
        name: "QUERY_CRM_PLAN_TYPE",
        params
      });
    },
    detailCrmPlanList({ commit }, params) {
      return post({
        commit,
        url: `/basic/crm_plan/detail`,
        name: "DETAILS_CRM_PLAN_LIST",
        params
      });
    },
    editCrmPlanList({ commit }, params) {
      return post({
        commit,
        url: `/basic/crm_plan/edit`,
        name: "EDIT_CRM_PLAN_LIST",
        params
      });
    },
    delCrmPlanList({ commit }, params) {
      return post({
        commit,
        url: `/basic/crm_plan/delete`,
        name: "DEL_CRM_PLAN_LIST",
        params
      });
    },
    queryAgeGroupConfig({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/query_age_group_config`,
        name: "QUERY_AGE_GROUP_CONFIG",
        params
      });
    },
    querySysConfig({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/query_member_group_config`,
        name: "QUERY_SYS_CONFIG",
        params
      });
    },
    editMemberGroupConfig({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/edit_member_group_config`,
        name: "EDIT_MEMBER_GROUP_CONFIG",
        params
      });
    },
    edityAgeGroupConfig({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/edit_age_group_config`,
        name: "EDIT_AGE_GROUP_CONFIG",
        params
      });
    },
    queryUnusedList({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/coupon/unused_list`,
        name: "QUERY_UNUSED_LIST",
        params
      });
    },
    balanceRefund({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/coupon_frozen/balance_refund`,
        name: "BALANCE_REFUND",
        params
      });
    },
    batchAddmember({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/batchAdd`,
        name: "BATCH_MEMBER_ADD",
        params
      });
    },
    memberRegister({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/memberRegister`,
        name: "STORE_MEMBER_CENTER_INFO",
        params
      });
    },
    memberRegisterPlus({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/card_type_update`,
        name: "STORE_MEMBER_CENTER_INFO_PLUS",
        params
      });
    },
    rightMove({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/right_move`,
        name: "RIGHT_MOVE",
        params
      });
    },
    rightMoveDo({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/right_move_do`,
        name: "RIGHT_MOVE_DO",
        params
      });
    },
    rightCancel({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/right_cancel`,
        name: "RIGHT_CANCEL",
        params
      });
    },
    delCenterLabel({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeMemberLabelInfo/delCenterLabel`,
        name: "DEL_CENTER_LABEL",
        params
      });
    },
    queryAllLabel({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeMemberLabelInfo/queryAllLabel`,
        name: "QUERY_ALL_LABEL",
        params
      });
    },
    addLabelToCenter({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeMemberLabelInfo/addLabelToCenter`,
        name: "ADD_LABEL_CENTER",
        params
      });
    },
    queryDetailsConfigInfo({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/rule/basic_config_info`,
        name: "BASIC_CONFIG_INFO",
        params
      });
    },
    testCrmPlan({ commit }, params) {
      return post({
        commit,
        url: `/basic/crm_plan/test_crm_plan`,
        name: "TEST_CRM_PLAN",
        params
      });
    },
    testAutoTask({ commit }, params) {
      return post({
        commit,
        url: `/guider/task/test_auto_task`,
        name: "TEST_AUTO_TASK",
        params
      });
    },
    queryIntegralRuleList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeIntegralRewardRule/list`,
        name: "QUERY_INTEGRAL_RULE_LIST",
        params
      });
    },
    queryIntegralRuleDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/storeIntegralRewardRule/details`,
        name: "QUERY_INTEGRAL_RULE_DETAILS",
        params
      });
    },
    editIntegralRuleDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/storeIntegralRewardRule/edit`,
        name: "EDIT_INTEGRAL_RULE_DETAILS",
        params
      });
    },
    queryIntegralOverdueRule({ commit }, params) {
      return post({
        commit,
        url: `/store/storeIntegralRewardRule/queryIntegralOverdueRule`,
        name: "QUERY_INTEGRAL_DUE_RULE",
        params
      });
    },
    saveIntegralOverdueRule({ commit }, params) {
      return post({
        commit,
        url: `/store/storeIntegralRewardRule/saveIntegralOverdueRule`,
        name: "SAVE_INTEGRAL_DUE_RULE",
        params
      });
    },
    batchAllotr({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/batch_binding_and_UnBundling`,
        name: "BATCH_ALLOTR",
        params
      });
    },
    memberCancel({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/memberCancel`,
        name: "MEMBER_CANCEL",
        params
      });
    },
    queryStoreMemberReferChangeRecordList({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/queryStoreMemberReferChangeRecordList`,
        name: "QUERY_STORE_MEMBER_REFER_CHANGE",
        params
      });
    },
    queryRegRewardConfig({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberRegConfig/queryRegRewardConfig`,
        name: "QUERY_REG_REWARD_CONFIG",
        params
      });
    },
    queryMemberRegConfigList({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberRegConfig/queryMemberRegConfigList`,
        name: "QUERY_MEMBER_REG_REWARD_CONFIG",
        params
      });
    },
    saveRegRewardConfig({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberRegConfig/saveRegRewardConfig`,
        name: "SAVE_REG_REWARD_CONFIG",
        params
      });
    },
    editRegRewardConfig({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberRegConfig/editRegRewardConfig`,
        name: "EDIT_REG_REWARD_CONFIG",
        params
      });
    },
    addMemberAssistant({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/member_assistant`,
        name: "ADD_MEMBER_ASSISTANT",
        params
      });
    },
    memberGoldBeanInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBeanRule/member_gold_bean/info`,
        name: "MEMBER_GOLD_BEAN_INFO",
        params
      });
    },
    memberGoldBeanFlow({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBean/mini/member_gold_bean/flow`,
        name: "MEMBER_GOLD_BEAN_FLOW",
        params
      });
    },
    basic_plus_rule_list({ commit }, params) {   //卡规则列表查询
      return post({
        commit,
        url: `/basic/plus/rule/list`,
        name: "BASIC_PLUS_RULE_LIST",
        params
      });
    },
    applyUpdateMemberGoldBeanNum({ commit }, params) {
      return post({
        commit,
        url: `/store/storeGoldBeanRule/applyUpdateMemberGoldBeanNum`,
        name: "APPLY_EDIT_MEMBER_GOLD_BEAN_NUM",
        params
      });
    },
    mp_member({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberRegConfig/getByStoreCodeAndType`,
        name: "MP_MEMBER",
        params
      });
    },
    query_member_record({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/member_view_mini_record`,
        name: "QUERY_MEMBER_RECORD",
        params
      });
    },
    queryInvitationLoad({ commit }, params) {
      return post({
        commit,
        url: `/store/member/invitation/rule/load`,
        name: "QUERY_INVITATION_LOAD",
        params
      });
    },
    queryInvitationAdd({ commit }, params) {
      return post({
        commit,
        url: `/store/member/invitation/rule/add`,
        name: "QUERY_INVITATION_ADD",
        params
      });
    },
    queryInvitationEdit({ commit }, params) {
      return post({
        commit,
        url: `/store/member/invitation/rule/edit`,
        name: "QUERY_INVITATION_EDIT",
        params
      });
    },
    queryInvitations({ commit }, params) {
      return post({
        commit,
        url: `/store/member/invitation/record/invitations`,
        name: "QUERY_INVITATIONS",
        params
      });
    },
    queryBeInvitations({ commit }, params) {
      return post({
        commit,
        url: `/store/member/invitation/record/beInvitations`,
        name: "QUERY_BE_INVITATIONS",
        params
      });
    },
    queryPlusOverdue({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/overdue/tip/query`,
        name: "QUERY_PLUS_OVERDUE",
        params
      });
    },
    settingPlusOverdue({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/overdue/tip/setting`,
        name: "SETTING_PLUS_OVERDUE",
        params
      });
    },
    updateOverdueSmsReminderDateRule({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/updateOverdueSmsReminderDateRule`,
        name: "UPDATE_OVERDUE_SMS_REMINDER_DATE_RULE",
        params
      });
    },
    overdueSmsReminderBeforeDateRang({ commit }, params) {
      return post({
        commit,
        url: `/overdue_sms_reminder_before_date_rang`,
        name: "OVERDUE_SMS_REMINDER_BEFORE_DATE_RANG",
        params
      });
    },
    queryPlusRightAdCouponList({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/queryPlusRightAdCouponList`,
        name: "QUERY_PLUS_RIGHT_AD_COUPON_LIST",
        params
      });
    },
    syncPlusMemberSendDetails({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/basic/plus/syncPlusMemberSendDetails`,
        name: "SYNC_PLUS_MEMBER_SEND_DETAILS",
        params
      });
    },
    removeMemberByMobile({ commit }, params) {
      return post({
        commit,
        url: `/mp_member/storeMemberCenterInfo/removeMemberByMobile`,
        name: "REMOVE_MEMBER_BY_MOBILE",
        params
      });
    },
  }
};

export default memberCenter;
